import Glide from '@glidejs/glide';

document.addEventListener("DOMContentLoaded", function () {
  imageSlider();
});

// Image slider
function imageSlider() {
  let sliders = document.querySelectorAll(".image-slider__wrapper");
  sliders.forEach((sliderElement) => {
    let slider = new Glide(sliderElement, {
      type: "carousel",
      perView: 2,
      gap: 24,
      focusAt: "center",
      breakpoints: {
        767: {
          perView: 1,
        },
      },
    });

    slider.mount();
  });
}